import { FC } from "react";
import clsx from "clsx";

export const SkeletonBlock: FC<{ className?: string }> = ({ className }) => (
  <div className={clsx("animate-pulse rounded-md bg-background-subtle", className)} />
);

export const DetailsCardSkeleton = () => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-wrap items-start justify-between gap-3 md:gap-4">
      <div className="flex flex-1 items-center gap-2 md:gap-4">
        <div className="outline-border-subtle aspect-square size-20 shrink-0 rounded-sm p-2 outline md:size-28">
          <SkeletonBlock className="size-full rounded-sm" />
        </div>
        <div className="flex flex-col gap-2">
          <SkeletonBlock className="h-5 w-28 md:h-8 md:w-48" />
          <SkeletonBlock className="h-4 w-24 md:w-32" />
        </div>
      </div>
      <SkeletonBlock className="h-7 w-28 rounded-full" />
    </div>
    <div className="flex flex-col gap-2">
      <SkeletonBlock className="h-3.5 w-full" />
      <SkeletonBlock className="h-3.5 w-full" />
      <SkeletonBlock className="h-3.5 w-3/5" />
    </div>
  </div>
);

export const ChipsSkeleton = () => (
  <div className="flex flex-wrap gap-2">
    {Array.from({ length: 3 }).map((_, i) => (
      <SkeletonBlock key={i} className="h-12 min-w-24 flex-1 rounded-sm" />
    ))}
  </div>
);

export const RedeemBarSkeleton = () => (
  <div className="flex items-center justify-between gap-4 md:gap-6">
    <div className="flex flex-col gap-2">
      <SkeletonBlock className="h-3 w-20" />
      <div className="flex items-center gap-2">
        <SkeletonBlock className="size-6 rounded-full" />
        <SkeletonBlock className="h-6 w-24 md:w-32" />
      </div>
    </div>
    <SkeletonBlock className="h-12 w-40 shrink-0 md:w-64" />
  </div>
);
